import client from "libs/HttpClient";

/**
 * Service class for handling Common.
 */
class CommonService {
  /**
   * get Country List based on the provided request.
   *
   * @param request - The request parameters for getting a Country.
   * @returns A Promise that resolves to the Axios response for the update Country request.
   */
  static getCountryList(request: any) {
    return client.get("admin/common/get-country-list", request);
  }

  /**
   * Retrieves the details of a State based on the provided parameters.
   *
   * @param params - The parameters for retrieving the State details.
   * @returns A Promise that resolves to the Axios response containing the State details.
   */
  static getStateList(params: any) {
    return client.get("admin/common/get-state-list", { params });
  }

  /**
   * Retrieves the details of a get convert amount based on the provided parameters.
   *
   * @param params - The parameters for retrieving the get convert amount details.
   * @returns A Promise that resolves to the Axios response containing the get convert amount details.
   */
  static getConvertedAmount(params: any) {
    return client.get("admin/common/get-convert-amount", { params });
  }

  /**
   * Updates the currency based on the provided request.
   *
   * @param request - The request parameters for updating the currency .
   * @returns A Promise that resolves to the Axios response for the update currency.
   */
  static updateCurrency(request: any) {
    return client.patch("admin/common/update-currency", request);
  }

  /**
   * Retrieves the details of a Phone Code based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Phone Code details.
   * @returns A Promise that resolves to the Axios response containing the Phone Code details.
   */
  static getPhoneCodeList(params: any) {
    return client.get("admin/common/get-phone-code", { params });
  }
}

export { CommonService };
